var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrowserEdge = function SvgBrowserEdge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1792 1792"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 795h1q16-126 58.5-241.5t115-217 167.5-176T634.5 43 911 0q231 0 414 105.5T1619 409q104 187 104 442v188H598q1 111 53.5 192.5T788 1354t189.5 57 213 3 208-46.5T1572 1283v377q-92 55-229.5 92t-312.5 38-316-53q-189-73-311.5-249T278 1116q-3-242 111-412t325-268q-48 60-78 125.5T590 721h635q8-77-8-140t-47-101.5-70.5-66.5-80.5-41-75-20.5-56-8.5l-22-1q-135 5-259.5 44.5T383 491 207 631.5 69 795"
  })));
};
export default SvgBrowserEdge;